// Function to generate section data
const getSectionData = (id, section, selector) => ({ id, section, selector });

// Function to validate custom checkboxes and control checkout button
function validateCartCheckboxes() {
  const termsCheckbox = document.getElementById("custom-terms");
  const guidelinesCheckbox = document.getElementById("custom-guidelines");
  const checkoutBtn = document.querySelector('button[name="checkout"]');

  if (!termsCheckbox || !guidelinesCheckbox || !checkoutBtn) return;

  // Remove existing listeners and observer to prevent duplicates
  if (checkoutBtn._checkboxValidationSetup) return;
  checkoutBtn._checkboxValidationSetup = true;

  let isUpdating = false;

  function updateCheckoutButton() {
    if (isUpdating) return;
    isUpdating = true;

    const shouldEnable = termsCheckbox.checked && guidelinesCheckbox.checked;

    if (shouldEnable) {
      checkoutBtn.disabled = false;
      checkoutBtn.style.opacity = "1";
      checkoutBtn.style.pointerEvents = "auto";
      checkoutBtn.removeAttribute('disabled');
    } else {
      checkoutBtn.disabled = true;
      checkoutBtn.style.opacity = "0.5";
      checkoutBtn.style.pointerEvents = "none";
      checkoutBtn.setAttribute('disabled', 'disabled');
    }

    setTimeout(() => { isUpdating = false; }, 50);
  }

  // Initial state
  updateCheckoutButton();

  // Add event listeners
  termsCheckbox.addEventListener("change", updateCheckoutButton);
  guidelinesCheckbox.addEventListener("change", updateCheckoutButton);

  // Watch for external changes to the button (e.g., from third-party scripts)
  const observer = new MutationObserver((mutations) => {
    if (isUpdating) return;

    const shouldEnable = termsCheckbox.checked && guidelinesCheckbox.checked;
    const isDisabled = checkoutBtn.disabled || checkoutBtn.hasAttribute('disabled');

    // Only intervene if state doesn't match expected
    if (!shouldEnable && !isDisabled) {
      updateCheckoutButton();
    }
  });

  observer.observe(checkoutBtn, {
    attributes: true,
    attributeFilter: ['disabled']
  });
}

// Check cart drawer and set sections to render
const cartDrawer = document.querySelector('cart-drawer');
let sectionsToRender = [];

if (cartDrawer) {
  const mainCartId = document.getElementById('main-cart-items')?.dataset.id;
  if (mainCartId) {
    sectionsToRender = [
      getSectionData(`#shopify-section-${mainCartId}`, mainCartId, `#shopify-section-${mainCartId} cart-items`),
      getSectionData("#cart-counter", "cart-counter", "#shopify-section-cart-counter"),
      getSectionData("#CartDrawer-Body", "cart-drawer", "#shopify-section-cart-drawer #CartDrawer-Body")
    ];
  } else {
    sectionsToRender = [
      getSectionData("#CartDrawer-Body", "cart-drawer", "#shopify-section-cart-drawer #CartDrawer-Body")
    ];
  }
} else {
  const mainCartId = document.getElementById('main-cart-items')?.dataset.id;
  if (mainCartId) {
    sectionsToRender = [
      getSectionData(`#shopify-section-${mainCartId}`, mainCartId, `#shopify-section-${mainCartId} cart-items`),
      getSectionData('#cart-counter', 'cart-counter', '#shopify-section-cart-counter')
    ];
  } else {
    sectionsToRender = [];
  }
}

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', event => {
      event.preventDefault();
      const cartItems =
        this.closest('cart-drawer-items') ||
        this.closest('cart-items');
      cartItems.updateQuantity(this.dataset.index, 0);
      updateFreeShipping();
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.freeShipping = document.querySelectorAll('shipping-bar');

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce(event => {
      this.onChange(event);
    }, 300);
    this.addEventListener(
      'change', this.debouncedOnChange.bind(this)
    );

    updateFreeShipping();
  }

  calculateTotalItemCount(items) {
    return items.reduce((total, item) => total + item.quantity, 0);
  }

  onChange(event) {
    if (event.target.name !== 'updates[]') return;

    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name')
    );
  }

  getSectionsToRender() {
    return sectionsToRender;
  }

  updateQuantity(line, quantity, name) {
    this.classList.add('is-loading');

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map(section => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {
      ...fetchConfig(),
      ...{ body }
    })
      .then(response => response.text())
      .then(state => {
        const parsedState = JSON.parse(state);

        // Save scroll position
        const cartDrawerBody = document.querySelector('#CartDrawer-Body');
        const cartDrawerInner = document.querySelector('.cart-drawer__inner');
        const cartDrawerMain = document.querySelector('.cart-drawer__main');

        const scrollPositions = [
          { selector: '#CartDrawer-Body', top: cartDrawerBody ? cartDrawerBody.scrollTop : 0 },
          { selector: '.cart-drawer__inner', top: cartDrawerInner ? cartDrawerInner.scrollTop : 0 },
          { selector: '.cart-drawer__main', top: cartDrawerMain ? cartDrawerMain.scrollTop : 0 }
        ];

        this.getSectionsToRender()?.forEach(section => {
          const elementToReplace = document.querySelector(section.selector) || document.querySelector(section.id);


          if (elementToReplace) {
            if (!parsedState.errors) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            }
          } else {
            console.error(`Element with selector ${section.selector} not found`);
          }

        });

        // Restore scroll position
        scrollPositions.forEach(pos => {
          const element = document.querySelector(pos.selector);
          if (element && pos.top > 0) {
            element.scrollTop = pos.top;
          }
        });

        if (!parsedState.errors) {
          this.totalItemCount = this.calculateTotalItemCount(parsedState.items);
        }
        this.updateLiveRegions(line, parsedState.item_count, parsedState.errors);

        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`))
          lineItem.querySelector(`[name="${name}"]`).focus();

        updateCartCounters();
        updateFreeShipping();
        validateCartCheckboxes();

        // --- NEW: Always fetch latest cart sections if cart drawer is open ---
        // /*
        // const cartDrawer = document.querySelector('cart-drawer');
        // if (cartDrawer && cartDrawer.classList.contains('is-visible')) {
        //   const sections = cartDrawer.getSectionsToRender().map(section => section.section).join(',');
        //   fetch(`/?sections=${sections}`)
        //     .then(res => res.json())
        //     .then(sectionsResponse => {
        //       cartDrawer.renderContents({ sections: sectionsResponse }, false);
        //     });
        // }
        // */
        // --- END NEW ---
      })
      .finally(() => this.classList.remove('is-loading'));
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  updateLiveRegions(line, itemCount, parsedError) {
    if (parsedError) {
      document
        .querySelectorAll(`[data-line-item-error][data-line="${line}"]`)
        .forEach(error => {
          error.innerHTML = parsedError;
        });
    }

    this.currentItemCount = itemCount;
  }
}
customElements.define('cart-items', CartItems);

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.isOpening = false; // Prevent multiple simultaneous opens
    this.addEventListener("keyup", event => event.code.toUpperCase() === "ESCAPE" && this.close());
    this.setCartLink();
    this.parentElement.addEventListener("shopify:section:select", () => this.open());
    this.parentElement.addEventListener("shopify:section:deselect", () => this.close());
  }

  setCartLink() {
    const cartLink = document.querySelector("[data-cart-link]");
    if (cartLink) {
      cartLink.setAttribute("role", "button");
      cartLink.setAttribute("aria-haspopup", "dialog");
      cartLink.addEventListener("click", event => {
        event.preventDefault();
        this.open(cartLink);
      });
      cartLink.addEventListener("keydown", event => {
        if (event.code.toUpperCase() !== "SPACE") return;
        event.preventDefault();
        this.open(cartLink);
      });
    } else {
      console.error("Cart link not found");
    }
  }

  open(opener) {
    if (this.isOpening || this.classList.contains("is-visible")) return;
    this.isOpening = true;
    const sections = this.getSectionsToRender().map(section => section.section).join(',');
    const sectionsUrl = encodeURIComponent(window.location.pathname);
    fetch(`/?sections=${sections}&sections_url=${sectionsUrl}`)
      .then(res => res.json())
      .then(sectionsResponse => {
        this.renderContents({ sections: sectionsResponse }, false); // update contents, don't auto-open yet
        // Now open the drawer
        if (opener) this.setActiveElement(opener);
        this.classList.add("is-visible");
        document.querySelector('body').style.overflow = 'hidden';
        this.addEventListener("transitionend", () => { this.focusOnCartDrawer(); }, { once: true });

        setTimeout(() => {
          document.addEventListener("click", this.handleOutsideClick);
        }, 100);

        const productReccomendations = document.querySelector(".product-recommendations");
        if (productReccomendations) {
          if (productReccomendations.classList.contains("hidden")) {
            document.querySelector(".cart-drawer-items").classList.add("cart-drawer-items__full");
          } else {
            document.querySelector(".cart-drawer-items").classList.remove("cart-drawer-items__full");
          }
        }
      })
      .finally(() => {
        this.isOpening = false;
      });
  }

  close() {
    this.classList.remove("is-visible");
    document.querySelector('body').style.overflow = 'auto';
    removeTrapFocus(this.activeElement);

    document.removeEventListener("click", this.handleOutsideClick);

    const isHeaderMenuOpen = header.classList.contains("menu-open");

    if (isHeaderMenuOpen) {
      return;
    }

    // if we are on the cart page, resubmit form
    if (window.location.pathname === "/cart") {
      const cartDrawerForm = document.getElementById("CartDrawer-FormSummary");
      if (cartDrawerForm) {
        cartDrawerForm.submit();
      }
    }
  }

  handleOutsideClick = event => {
    const cartDrawerInner = this.querySelector(".cart-drawer__inner");
    if (cartDrawerInner && !cartDrawerInner.contains(event.target)) {
      this.close();
    }
  };

  setActiveElement(element) {
    this.activeElement = element;
  }

  focusOnCartDrawer() {
    const containerToTrapFocusOn = this.firstElementChild;
    const focusElement = this.querySelector("[data-drawer-close]");
    trapFocus(containerToTrapFocusOn, focusElement);
  }

  // renderContents(response, open = false) {
  //   // Only update contents, never open the drawer automatically here
  //
  //   // Save scroll position
  //   const cartDrawerBody = document.querySelector('#CartDrawer-Body');
  //   const cartDrawerInner = document.querySelector('.cart-drawer__inner');
  //   const cartDrawerMain = document.querySelector('.cart-drawer__main');
  //
  //   const scrollPositions = [
  //     { selector: '#CartDrawer-Body', top: cartDrawerBody ? cartDrawerBody.scrollTop : 0 },
  //     { selector: '.cart-drawer__inner', top: cartDrawerInner ? cartDrawerInner.scrollTop : 0 },
  //     { selector: '.cart-drawer__main', top: cartDrawerMain ? cartDrawerMain.scrollTop : 0 }
  //   ];
  //
  //   this.getSectionsToRender()?.forEach(section => {
  //     const sectionElement = document.querySelector(section.id);
  //     if (!sectionElement) return;
  //     sectionElement.innerHTML = this.getSectionInnerHTML(
  //       response.sections[section.section],
  //       section.selector
  //     );
  //     updateCartCounters();
  //   });
  //
  //   // Restore scroll position
  //   scrollPositions.forEach(pos => {
  //     const element = document.querySelector(pos.selector);
  //     if (element && pos.top > 0) {
  //       element.scrollTop = pos.top;
  //     }
  //   });
  //
  //   // Do NOT open the drawer here. Only open in response to direct user actions.
  //   // if (open) { this.open(); }
  // }

  renderContents(response, open = false) {
    // Only update contents, never open the drawer automatically here

    // Save scroll position
    const cartDrawerBody = document.querySelector('#CartDrawer-Body');
    const cartDrawerInner = document.querySelector('.cart-drawer__inner');
    const cartDrawerMain = document.querySelector('.cart-drawer__main');

    const scrollPositions = [
      { selector: '#CartDrawer-Body', top: cartDrawerBody ? cartDrawerBody.scrollTop : 0 },
      { selector: '.cart-drawer__inner', top: cartDrawerInner ? cartDrawerInner.scrollTop : 0 },
      { selector: '.cart-drawer__main', top: cartDrawerMain ? cartDrawerMain.scrollTop : 0 }
    ];

    this.getSectionsToRender()?.forEach(section => {
      const sectionElement = document.querySelector(section.id);
      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(
        response.sections[section.section],
        section.selector
      );
      updateCartCounters();
    });

    // Restore scroll position
    scrollPositions.forEach(pos => {
      const element = document.querySelector(pos.selector);
      if (element && pos.top > 0) {
        element.scrollTop = pos.top;
      }
    });

    // Fix cart URLs to include current locale prefix
    this._fixCartUrls();

    // Validate cart checkboxes after content update
    validateCartCheckboxes();

    // Do NOT open the drawer here. Only open in response to direct user actions.
    // if (open) { this.open(); }
  }

  _fixCartUrls() {
    // Get locale prefix from current URL (e.g. '/en-gb' or '')
    const localePrefix = window.location.pathname.match(/^(\/[a-z]{2}-[a-z]{2})\//)?.[1] || '';
    if (!localePrefix) return;

    const correctCartUrl = localePrefix + '/cart';

    // Fix form actions
    this.querySelectorAll('form[action="/cart"]').forEach(form => {
      form.setAttribute('action', correctCartUrl);
    });

    // Fix anchor links
    this.querySelectorAll('a[href="/cart"]').forEach(link => {
      link.setAttribute('href', correctCartUrl);
    });
  }

  getSectionsToRender() {
    return sectionsToRender;
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
}
customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return sectionsToRender;
  }
}
customElements.define("cart-drawer-items", CartDrawerItems);
